module.exports = __webpack_public_path__ + "static/media/use-case-1.7c39f4b6.jpg";